import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getBorder, getCssClasses, getIsHidden, getMargin, getPadding, getTextAlign } from '../../utils';
export default (node => {
  if (!node.childNodes[0]) {
    return {};
  }
  var imageNode = node.childNodes[0].nodeName === 'A' ? node.childNodes[0].childNodes : node.childNodes;
  var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    desktopImage: imageNode[0] ? imageNode[0].getAttribute('src') : null,
    mobileImage: imageNode[1] ? imageNode[1].getAttribute('src') : null,
    altText: imageNode[0] ? imageNode[0].getAttribute('alt') : null,
    title: imageNode[0] ? imageNode[0].getAttribute('title') : null,
    openInNewTab: node.childNodes[0].getAttribute('target') === '_blank'
  }, getPadding(node)), getMargin(node)), imageNode[0] ? getBorder(imageNode[0]) : []), getCssClasses(node)), getTextAlign(node)), getIsHidden(node));
  if (props.desktopImage === props.mobileImage) {
    props.mobileImage = null;
  }
  if (node.childNodes[0].nodeName === 'A') {
    props.link = node.childNodes[0].getAttribute('href');
    props.linkType = node.childNodes[0].getAttribute('data-link-type');
  }
  var captionElement = node.querySelector('figcaption');
  if (captionElement) {
    props.caption = captionElement.textContent;
  }
  return props;
});